/* Global Variables for later usage */
var _isMobile = window.matchMedia("only screen and (max-width: " + (768 - 1) + "px)");
var _isTablet = window.matchMedia("only screen and (min-width: " + 768 + "px) and (max-width: " + (1024 - 1) + "px)");
var _isDesktop = window.matchMedia("only screen and (min-width: " + 1024 + "px)");

/**//*! GremlinJS 0.6.0 (2013-11-10) - http://grml.in - Licensed under MIT license  */!function(a,b){b["true"]=a,!function(a){window.onDomReady=a()}(function(){"use strict";function a(b){if(!v){if(!g.body)return d(a);for(v=!0;b=w.shift();)d(b)}}function b(b){(t||b.type===i||g[m]===l)&&(c(),a())}function c(){t?(g[s](q,b,j),f[s](i,b,j)):(g[o](r,b),f[o](k,b))}function d(a,b){setTimeout(a,+b>=0?b:1)}function e(a){v?d(a):w.push(a)}var f=window,g=f.document,h=g.documentElement,i="load",j=!1,k="on"+i,l="complete",m="readyState",n="attachEvent",o="detachEvent",p="addEventListener",q="DOMContentLoaded",r="onreadystatechange",s="removeEventListener",t=p in g,u=j,v=j,w=[];if(g[m]===l)d(a);else if(t)g[p](q,b,j),f[p](i,b,j);else{g[n](r,b),f[n](k,b);try{u=null==f.frameElement&&h}catch(x){}u&&u.doScroll&&function y(){if(!v){try{u.doScroll("left")}catch(b){return d(y,50)}c(),a()}}()}return e.version="1.3",e});var c;c=function(){function a(){this._events={}}return a.prototype.on=function(a,b){return this._events[a]=this._events[a]||[],this._events[a].push(b)},a.prototype.off=function(a,b){return!1!=a in this._events?this._events[a].splice(this._events[a].indexOf(b),1):void 0},a.prototype.emit=function(a){var b,c;if(this._events=this._events||{},!1!=a in this._events){for(b=0,c=[];b<this._events[a].length;)this._events[a][b].apply(this,Array.prototype.slice.call(arguments,1)),c.push(b++);return c}},a}();var d={}.hasOwnProperty,e=[].slice,f={};f.Helper=function(){function a(){}var b;return b=function(a,b){var c,e;for(c in b)d.call(b,c)&&(e=b[c],a[c]=e);return a},a.extend=function(){var a,b,c,d,f,g,h;for(d=arguments[0],c=2<=arguments.length?e.call(arguments,1):[],g=0,h=c.length;h>g;g++)for(a in b=c[g])f=b[a],d[a]=f;return d},a.mixin=function(a,c){return b(a.prototype,c)},a.clone=function(a){var b,c;if(null==a||"object"!=typeof a)return a;if(a instanceof Date)return new Date(a.getTime());if(a instanceof RegExp)return b="",null!=a.global&&(b+="g"),null!=a.ignoreCase&&(b+="i"),null!=a.multiline&&(b+="m"),null!=a.sticky&&(b+="y"),RegExp(a.source,b);c=new a.constructor;for(b in a)c[b]=f.Helper.clone(a[b]);return c},a.hasClass=function(a,b){return b=b.trim(),null===a.className.match(RegExp("(\\s|^)"+b+"(\\s|$)"))?!1:!0},a.addClass=function(a,b){return b=b.trim(),f.Helper.hasClass(a,b)||(a.className+=" "+b),a.className=a.className.trim()},a.removeClass=function(a,b){var c;return b=b.trim(),f.Helper.hasClass(a,b)?(c=RegExp("(\\s|^)"+b+"(\\s|$)"),a.className=a.className.replace(c," "),a.className=a.className.trim()):void 0},a.addStyleSheet=function(a){var b,c;return b=document.getElementsByTagName("head")[0],c=document.createElement("style"),c.type="text/css",c.styleSheet?c.styleSheet.cssText=a:c.appendChild(document.createTextNode(a)),b.appendChild(c)},a}(),f.Debug=function(){function a(a){this._isDebug=a,this._gremlins=[],this._broken=[],this._logEl=null,this._createLog(),this._createConsole()}var b,c,d,e,g;return b="debug error info log warn dir dirxml trace assert count markTimeline profile profileEnd time timeEnd timeStamp group groupCollapsed groupEnd".split(" "),c="function"==typeof Function.prototype.bind,d="function"==typeof(null!=(g=window.console)?g.log:void 0),e=function(){},a.prototype._createLog=function(){return this._isDebug?(this._logEl=document.createElement("div"),this._logEl.className="gremlinjs-log",document.body.appendChild(this._logEl)):void 0},a.prototype._createConsole=function(){var a,g,h,i;if(this.console={},this._isDebug&&f.Helper.addStyleSheet(".gremlinjs-log {\nposition: fixed;\nbottom: 0;\nleft: 0;\nbackground: #fff;\npadding: 4px 6px;\n-webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.3);\nbox-shadow: 0px 0px 4px 0px rgba(0,0,0,0.3);\nz-index: 9999;\n}\n\n.gremlinjs-log p {\n  font-size: 12px;\n  color: #666666;\n  margin: 0;\n  padding: 0;\n}\n\n.gremlinjs-log p span {\n  display: inline-block;\n  margin: 0 5px;\n  cursor: help;\n}\n\n.gremlinjs-log p .gremlinjs-log-ready{\ncolor: #41bb19;\n}\n\n.gremlinjs-log p .gremlinjs-log-waiting{\ncolor: #8d46b0;\n}\n\n.gremlinjs-log p .gremlinjs-log-pending{\ncolor: #fff;\nbackground: #fe781e;\npadding: 0 4px;\n}\n\n.gremlinjs-log p .gremlinjs-log-error{\ncolor: #fff;\nbackground: #f50f43;\npadding: 0 4px;\n}\n\n*[data-gremlin-found] {\noutline: 2px solid #41bb19;\n}\n\n*[data-gremlin-found]::before {\ncolor: #41bb19;\nfont-family: monospace;\ncontent: '[' attr(data-gremlin-found) '] ready';\nposition: absolute;\nmargin-top: -14px;\nfont-size: 11px;\nfont-weight: bold;\n}\n\n.gremlin-definition-pending {\noutline: 2px solid #fe781e;\n}\n.gremlin-definition-pending::before {\ncontent: '[' attr(data-gremlin-found) '] definition pendig...';\ncolor: #fe781e;\n}\n.gremlin-error {\noutline: 2px solid red;\n}\n\n.gremlin-error[data-gremlin-found]::before {\ncontent: 'faulty gremlin!';\ncolor: red;\n}"),d&&this._isDebug){for(i=[],g=0,h=b.length;h>g;g++)a=b[g],c?i.push(this.console[a]=console[a]?Function.prototype.bind.call(console[a],console):e):void 0!==console[a]?i.push(this.console[a]=function(){return Function.prototype.apply.call(console[a],console,arguments)}):i.push(this.console[a]=e);return i}for(i=[],g=0,h=b.length;h>g;g++)a=b[g],i.push(this.console[a]=e);return i},a.prototype.registerGremlin=function(a){return this._gremlins.push(a)},a.prototype.reportBrokenGremlin=function(a){return this._broken.push(a)},a.prototype.updateGremlinLog=function(){var a=this;return this._isDebug&&this._logEl?window.setTimeout(function(){var b,c,d,e,f,g,h,i,j,k,l;for(f=0,g={},h=0,i={},d=0,e={},b=a._broken.length,l=a._gremlins,j=0,k=l.length;k>j;j++)c=l[j],c.hasGremlin()?(f++,a._addName(g,c.name)):c.isLazy?(h++,a._addName(i,c.name)):(d++,a._addName(e,c.name));return b='<p>\n<span title="'+a._getTitle(g)+"\" class='gremlinjs-log-ready'><strong>"+f+'</strong> ready</span>\n<span title="'+a._getTitle(i)+"\" class='gremlinjs-log-waiting'><strong>"+h+'</strong> lazy waiting</span>\n<span title="'+a._getTitle(e)+"\" class='"+(d>0?"gremlinjs-log-pending":"")+"'><strong>"+d+"</strong> pending</span>\n<span class='"+(b>0?"gremlinjs-log-error":"")+"'><strong>"+b+"</strong> error(s)</span>\n</p>",a._logEl.innerHTML=b},50):void 0},a.prototype._addName=function(a,b){return a[b]?a[b]++:a[b]=1},a.prototype._getTitle=function(a){var b,c,d;c="";for(b in a)d=a[b],c+=""+d+"x "+b+" \n";return""===c?"":"Gremlins: \n"+c},a}();var g={};g.Configuration=function(){function a(a){this._options=f.Helper.extend({},b,a)}var b;return b={debug:!1},a.prototype.get=function(a){var b;return null!=(b=this._options[a])?b:null},a.options={DEBUG:"debug",AUTOLOAD:"autoload"},a}(),f.ready=window.onDomReady;var d={}.hasOwnProperty,h=function(a,b){function c(){this.constructor=a}for(var e in b)d.call(b,e)&&(a[e]=b[e]);return c.prototype=b.prototype,a.prototype=new c,a.__super__=b.prototype,a},i={};i.Gizmo=function(){function a(a,b,c,d){this.el=a,this.data=b,this.id=c,d.call(this)}var b;return b=function(a,b,c,e){var g;if("function"!=typeof b)throw Error("The second parameter when defining a gremlin has to be the constructor function!");if("undefined"!=typeof c&&"object"!=typeof c)throw Error("The third parameter when defining a gremlin has to be an object providing the instance members of the gremlin!");if("undefined"!=typeof e&&"object"!=typeof e)throw Error("The fourth parameter when defining a gremlin has to be an object providing the static members of the gremlin!");a=function(a){function c(){c.__super__.constructor.apply(this,arguments),b.call(this)}return h(c,a),c}(a),f.Helper.mixin(a,c);for(g in e)d.call(e,g)&&(c=e[g],a[g]=c);return a},a.extend=function(a,c,d){return b(this,a,c,d)},a.prototype.data=null,a.prototype.el=null,a.prototype.id=null,a}();var j={};j.ModuleCollection=function(){function a(){}var b,c,d;return d={},c={},b=function(a,b){var e,f,g;if(!c[a]){switch(e=b.include,typeof e){case"string":f=[e];break;case"object":f=Array.isArray(e)?e:[];break;default:f=[]}c[a]=function(){var a,b,c,e;for(e=[],a=0,b=f.length;b>a;a++)g=f[a],e.push(function(){if(null!=(c=d[g]))return c;throw Error("The module "+g+" does not exists!")}());return e}()}return c[a]},a.registerModule=function(a){return d[a.name]=a},a.extendGizmo=function(a,c){var d,e,f,g,h;for(e=b(a,c),h=[],f=0,g=e.length;g>f;f++)d=e[f],h.push(d.extend(c));return h},a.bindGizmo=function(a,c){var d,e,f,g,h;for(e=b(a,c.constructor),h=[],f=0,g=e.length;g>f;f++)d=e[f],h.push(d.bind(c));return h},a}(),i.Pool=function(){function a(){}var b,c;return c=null,b={},a=function(){function a(){}return a.prototype.get=function(a){var c;return null!=(c=b[a])?c:null},a.prototype.set=function(a,c){if("undefined"!=typeof b[a])throw Error("Trying to add new Gremlin definition, but a definition for "+a+" already exists.");return j.ModuleCollection.extendGizmo(a,c),b[a]=c},a.prototype.addClass=function(a,b){if("string"!=typeof a)throw Error("Please provide the name of the gremlin!");if("function"!=typeof b)throw Error("When adding a gremlin, you have to provide a constructor function!");return this.set(a,b),b},a}(),a.getInstance=function(){return null!=c?c:c=new a},a}();var k=function(a,b){return function(){return a.apply(b,arguments)}},l={clocks:{}};l.clocks.LegacyTimeoutClock=function(){function a(){this._onInterval=k(this._onInterval,this)}return a.prototype.observe=function(){return this._initiateInterval()},a.prototype._initiateInterval=function(){return this._interval=window.setTimeout(this._onInterval,500)},a.prototype._onInterval=function(){return this.onMutation(),this._initiateInterval()},a.prototype.onMutation=function(){},a}();var m={};m.NameProvider=function(){function a(){}var b;return b=function(a,b){var c;return"function"==typeof a.hasAttribute?a.hasAttribute(b):(c=a.getAttributeNode(b),!(!c||!c.specified&&!c.nodeValue))},a.DATA_NAME_ATTR="data-gremlin",a.isGremlin=function(a){return b(a,"data-gremlin")},a.getNames=function(a){var b,c;if(b=a.getAttribute("data-gremlin"),""===b)return b=null!=(c=a.outerHTML)?c:"",m.NameProvider.flagBrokenElement(a),r.debug.console.log("Couldn't process gremlin element, no gremlin names available, 'data-gremlin' is empty!\n"+b),[];var d,e;for(d=b.split(","),e=[],c=0,b=d.length;b>c;c++)a=d[c],e.push(a.trim());return e},a.flagBrokenElement=function(a){return f.Helper.addClass(a,"gremlin-error"),m.NameProvider.flagProcessedElement(a),r.debug.reportBrokenGremlin(a)},a.flagProcessedElement=function(a){var b;return b=a.getAttribute("data-gremlin"),a.removeAttribute("data-gremlin"),a.setAttribute("data-gremlin-found",b)},a}(),l.clocks.cssAnimationStyle=function(a){return a="@keyframes {{ANIMATION_NAME}} {\n  0%   { opacity: 0.9; }\n  100% { opacity: 1; }\n}\n\n@-moz-keyframes {{ANIMATION_NAME}} {\n  0%   { opacity: 0.9; }\n  100% { opacity: 1; }\n}\n\n@-webkit-keyframes {{ANIMATION_NAME}} {\n  0%   { opacity: 0.9; }\n  100% { opacity: 1; }\n}\n\n@-o-keyframes {{ANIMATION_NAME}} {\n  0%   { opacity: 0.9; }\n  100% { opacity: 1; }\n}\n\n*[{{GREMLIN_ATTRIBUTE}}] {\n  animation-duration: 1ms;\n  -o-animation-duration: 1ms;\n  -moz-animation-duration: 1ms;\n  -webkit-animation-duration: 1ms;\n  animation-name: {{ANIMATION_NAME}};\n  -o-animation-name: {{ANIMATION_NAME}};\n  -moz-animation-name: {{ANIMATION_NAME}};\n  -webkit-animation-name: {{ANIMATION_NAME}};\n}".replace(/{{ANIMATION_NAME}}/g,a),a.replace(/{{GREMLIN_ATTRIBUTE}}/g,m.NameProvider.DATA_NAME_ATTR)},k=function(a,b){return function(){return a.apply(b,arguments)}},l.clocks.CssAnimationClock=function(){function a(){this._onAnimation=k(this._onAnimation,this);var a;a=l.clocks.cssAnimationStyle(b),f.Helper.addStyleSheet(a)}var b,c;return b="gremlinInserted",c=["animationstart","webkitAnimationStart","oanimationstart"],a.prototype.observe=function(){var a,b,d,e;for(e=[],b=0,d=c.length;d>b;b++)a=c[b],e.push(document.body.addEventListener(a,this._onAnimation,!1));return e},a.prototype._onAnimation=function(a){return a.animationName===b?this.onMutation():void 0},a.prototype.onMutation=function(){},a}(),k=function(a,b){return function(){return a.apply(b,arguments)}},l.clocks.MutationObserverClock=function(){function a(){if(this._onMutation=k(this._onMutation,this),null===b)throw Error("Mutation Observer not available")}var b;return b=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver||null,a.prototype.observe=function(){return new b(this._onMutation).observe(document.body,{childList:!0,subtree:!0})},a.prototype._onMutation=function(a){var b,c,d,e;for(e=[],c=0,d=a.length;d>c;c++){if(b=a[c],"childList"===b.type){this.onMutation();break}e.push(void 0)}return e},a.prototype.onMutation=function(){},a}(),f.FeatureDetector=function(){function a(){}return a.hasQuerySelectorAll="undefined"!=typeof document.querySelectorAll,a.hasMutationObserver=!(!window.MutationObserver&&!window.WebKitMutationObserver&&!window.MozMutationObserver),a.hasGetClientRect=void 0!==document.documentElement.getBoundingClientRect,a.hasCssAnimations=function(){var a,b,c,d;if(c=document.documentElement,a=!1,b=["Webkit","Moz","O","ms","Khtml"],c.style.animationName&&(a=!0),!1===a)for(d=0;d<b.length;){if(void 0!==c.style[b[d]+"AnimationName"]){a=b[d],a.toLowerCase(),a=!0;break}d++}return a}(),a}(),l.clocks.ClockFactory=function(){function a(){}var b;return b=f.FeatureDetector.hasCssAnimations,a.createClock=function(){return new(b?l.clocks.CssAnimationClock:l.clocks.LegacyTimeoutClock)},a}();var n,k=function(a,b){return function(){return a.apply(b,arguments)}},d={}.hasOwnProperty,h=function(a,b){function c(){this.constructor=a}for(var e in b)d.call(b,e)&&(a[e]=b[e]);return c.prototype=b.prototype,a.prototype=new c,a.__super__=b.prototype,a};n=function(){function a(){}var b;return b=null,a=function(a){function b(){this._onMutation=k(this._onMutation,this),b.__super__.constructor.apply(this,arguments),this._clock=l.clocks.ClockFactory.createClock(),this._clock.onMutation=this._onMutation}return h(b,a),b.prototype._onMutation=function(){return this.emit(b.ON_MUTATION)},b.prototype.observe=function(){return this._clock.observe(),this._onMutation()},b}(c),a.ON_MUTATION="ON_MUTATION",a.get=function(){return null!=b?b:b=new a},a}.call(this),l.ElementList=function(){function a(a){this._attributeName=a}var b,c,d;return c=function(){function a(){}return a.get=function(a){var b,c,d,e;for(b=document.querySelectorAll("["+m.NameProvider.DATA_NAME_ATTR+"]"),e=[],c=0,d=b.length;d>c;c++)a=b[c],e.push(a);return e},a}(),b=function(){function a(){}return a.get=function(a){var b,c,d,e;for(b=document.getElementsByTagName("*"),e=[],c=0,d=b.length;d>c;c++)a=b[c],m.NameProvider.isGremlin(a)&&e.push(a);return e},a}(),d=f.FeatureDetector.hasQuerySelectorAll?c:b,a.prototype.getList=function(){return d.get(this._attributeName)},a}.call(this),k=function(a,b){return function(){return a.apply(b,arguments)}},l.DomObserver=function(){function a(){this._handleMutation=k(this._handleMutation,this),this._elementList=new l.ElementList}return a.prototype._bindMutations=function(){var a;return a=n.get(),a.on(n.ON_MUTATION,this._handleMutation),a.observe()},a.prototype._handleMutation=function(){var a;return a=this._elementList.getList(),0<a.length?this.onNewElements(a):void 0},a.prototype.observe=function(){return this._bindMutations()},a.prototype.onNewElements=function(){},a}(),m.GremlinFactory=function(){function a(){}var b,c;return c=function(){var a;return a=0,function(){return a++}}(),b=function(a){return function(){return j.ModuleCollection.bindGizmo(a,this)}},a.getInstance=function(a,d,e){var f;if(f=i.Pool.getInstance().get(a),"function"==typeof f){if(a=new f(d,e.toObject(),c(),b(a)),null===a.el)throw Error("Abstract gremlin class not called. Did you miss a super in your coffeescript-class?");return a}return null},a}(),f.ElementData={},f.ElementData.DataValue=function(){function a(a){this._dataString=a}var b;return b=/(?:\{[\s\S]*\}|\[[\s\S]*\])$/,a.prototype.parse=function(){var a,c;if(c=a=this._dataString,"string"==typeof this._dataString)try{c="true"===a?!0:"false"===a?!1:"null"===a?null:+a+""===a?+a:b.test(a)?JSON.parse(a):a}catch(d){}return c},a}(),d={}.hasOwnProperty,f.ElementData.ElementData=function(){function a(a){this._el=a,this._obj=c(this._el)}var b,c;return b=function(a){return a.toLowerCase().replace(/-(.)/g,function(a,b){return b.toUpperCase()})},c=function(a){var c,e,g,h;h={},void 0!==a.dataset?c=a.dataset:(c={},[].filter.call(a.attributes,function(d){var e;return(e=/^data-/.test(d.name))&&(c[b(d.name.substring(5))]=a.getAttribute(d.name)),e}));for(g in c)d.call(c,g)&&(e=c[g],e=new f.ElementData.DataValue(e),h[g]=e.parse());return h},a.prototype.get=function(a){var b;return null!=(b=this._obj[a])?b:null},a.prototype.toObject=function(){return f.Helper.clone(this._obj)},a}();var o;o=f.FeatureDetector.hasGetClientRect,m.GremlinDomElement=function(){function a(a,d){this._el=a,this._name=d,this._data=new f.ElementData.ElementData(this._el),this.isLazy=this._isLazy=!0===this._data.get(c)?!0:!1,this.name=this._name,this._triggeredPending=!1,f.Helper.addClass(this._el,b),r.debug.registerGremlin(this),r.emit(r.ON_ELEMENT_FOUND,this._el)}var b,c;return c="gremlinLazy",b="gremlin-loading",a.prototype._gremlinInstance=null,a.prototype.check=function(){return this._isInViewport()?this._create():void 0},a.prototype._isInViewport=function(){var a;return this._isLazy&&o?(a=document.documentElement.clientHeight,300>this._el.getBoundingClientRect().top-a):!0},a.prototype._create=function(){return this._gremlinInstance=m.GremlinFactory.getInstance(this._name,this._el,this._data),this.hasGremlin()?(f.Helper.removeClass(this._el,b),f.Helper.removeClass(this._el,"gremlin-definition-pending"),f.Helper.addClass(this._el,"gremlin-ready"),r.emit(r.ON_GREMLIN_LOADED,this._el)):this._triggeredPending?void 0:(this._triggeredPending=!0,f.Helper.addClass(this._el,"gremlin-definition-pending"),r.debug.console.info("Gremlin <"+this._name+"> found in the dom, but there is no definition for it at the moment."),r.emit(r.ON_DEFINITION_PENDING,this._el))},a.prototype.hasGremlin=function(){return null!==this._gremlinInstance},a}(),k=function(a,b){return function(){return a.apply(b,arguments)}},m.GremlinCollection=function(){function a(){this._scrollHandler=k(this._scrollHandler,this),this._queue=[],this._bindScroll(),this._scrollTimer=this._didScroll=!1}return a.prototype._queue=null,a.prototype._bindScroll=function(){return window.addEventListener?window.addEventListener("scroll",this._scrollHandler,!1):window.attachEvent?window.attachEvent("onscroll",this._scrollHandler):void 0},a.prototype.add=function(a){var b,c,d;for(c=0,d=a.length;d>c;c++)b=a[c],this._addGremlinElements(b);return this._processQueue()},a.prototype._addGremlinElements=function(a){var b,c,d,e,f;for(c=m.NameProvider.getNames(a),m.NameProvider.flagProcessedElement(a),f=[],d=0,e=c.length;e>d;d++)b=c[d],f.push(this._queue.push(new m.GremlinDomElement(a,b)));return f},a.prototype._processQueue=function(){var a,b,c,d,e;for(b=[],e=this._queue,c=0,d=e.length;d>c;c++)a=e[c],a.check(),a.hasGremlin()||b.push(a);return this._queue=b,r.debug.updateGremlinLog()},a.prototype.process=function(){return this._processQueue()},a.prototype._scrollHandler=function(){var a=this;return 0===this._queue.length?!0:(this._didScroll||(this._scrollTimer=setInterval(function(){return a._didScroll?(a._didScroll=!1,clearTimeout(a._scrollTimer),a.process()):void 0},250)),this._didScroll=!0)},a}();var p,k=function(a,b){return function(){return a.apply(b,arguments)}};p=function(){function a(){this._onNew=k(this._onNew,this);var a,c;a=null!=(c=new f.ElementData.ElementData(document.body).get(b))?c:{},this.configuration=new g.Configuration(a),this._observer=new l.DomObserver,this._coll=new m.GremlinCollection,this._observer.onNewElements=this._onNew}var b;return b="gremlinConfig",a.prototype._onNew=function(a){return this._coll.add(a)},a.prototype.start=function(){return this._observer.observe()},a.prototype.refresh=function(){return this._coll.process()},a}(),j.Module=function(){return function(a,b){var c,d;if(!(this instanceof j.Module))return function(a,b,c){return c.prototype=a.prototype,c=new c,a=a.apply(c,b),Object(a)===a?a:c}(j.Module,arguments,function(){});if(d="function"==typeof b.extend,c="function"==typeof b.bind,!d)throw Error("Missing .extend method in your module "+a);if(!c)throw Error("Missing .bind method in your module "+a);this.name=a,this.extend=b.extend,this.bind=b.bind,j.ModuleCollection.registerModule(this)}}();var q={};q.Package=function(){function a(a,c){return this instanceof q.Package?(this._package=b(a,c),void 0):function(a,b,c){return c.prototype=a.prototype,c=new c,a=a.apply(c,b),Object(a)===a?a:c}(q.Package,arguments,function(){})}var b,c;return c={},b=function(a,b){var d,e,f,g,h,i;for(null==b&&(b=null),e=a.split("."),f=e.pop(),g=c,h=0,i=e.length;i>h;h++)d=e[h],g=g[d]||(g[d]={});return g[f]=b||g[f]||(g[f]={})},a.require=function(a){return b(a)},a}(),f.polyfill={},"function"!=typeof String.prototype.trim&&(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),Array.prototype.filter||(Array.prototype.filter=function(a,b){var c,d,e,f,g;if("undefined"==typeof this||null===this)throw new TypeError;if(f=Object(this),d=f.length>>>0,"function"!=typeof a)throw new TypeError;for(e=[],c=0;d>c;)c in f&&(g=f[c],a.call(b,g,c,f)&&e.push(g)),c++;return e}),Array.isArray||(Array.isArray=function(a){return"[object Array]"===Object.prototype.toString.call(a)}),Array.prototype.indexOf||(Array.prototype.indexOf=function(a){if(null==this)throw new TypeError;var b,c=Object(this),d=c.length>>>0;if(0===d)return-1;if(b=0,1<arguments.length&&(b=Number(arguments[1]),b!=b?b=0:0!=b&&1/0!=b&&-1/0!=b&&(b=(b>0||-1)*Math.floor(Math.abs(b)))),b>=d)return-1;for(b=b>=0?b:Math.max(d-Math.abs(b),0);d>b;b++)if(b in c&&c[b]===a)return b;return-1});var r,d={}.hasOwnProperty,h=function(a,b){function c(){this.constructor=a}for(var e in b)d.call(b,e)&&(a[e]=b[e]);return c.prototype=b.prototype,a.prototype=new c,a.__super__=b.prototype,a};r=function(){var a,b;return a=null,b=new(function(b){function c(){c.__super__.constructor.apply(this,arguments),this.debug=new f.Debug(!1)}return h(c,b),c.prototype.ON_ELEMENT_FOUND="elementfound",c.prototype.ON_DEFINITION_PENDING="definitionpending",c.prototype.ON_GREMLIN_LOADED="gremlinloaded",c.prototype.add=function(b,c){return c=i.Pool.getInstance().addClass(b,c),null!=a&&a.refresh(),c},c.prototype.Gizmo=i.Gizmo,c.prototype.Helper=f.Helper,c.prototype.Module=j.Module,c.prototype.Package=q.Package,c}(c)),f.ready(function(){var c;return a=new p,(c=a.configuration.get(g.Configuration.options.DEBUG))&&(b.debug=new f.Debug(c)),a.start(),b.debug.console.log("gremlin.js up and running...")}),b}(),window.Gremlin=r,void 0===window.G&&(window.G=window.Gremlin),"function"==typeof window.define&&window.define.amd&&define("Gremlin",[],function(){return r})}({},function(){return this}());
 /**//*! gremlinjs-interests - v0.2.0 - 2013-11-10 */(function(){var a,b;a=function(){function a(){}var b;return b={},a.registerHandler=function(a,c,d){var e;return b[a]=null!=(e=b[a])?e:[],b[a].push({handler:c,ctx:d})},a.dispatch=function(a,c){return void 0!==b[a]?window.setTimeout(function(){var d,e,f,g,h;for(g=b[a],h=[],e=0,f=g.length;f>e;e++)d=g[e],h.push(d.handler.call(d.ctx,c));return h},10):void 0},a}(),b=function(){var b,c,d,e,f;d=null!=(e=this.constructor.interests)?e:{},f=[];for(c in d){if(b=d[c],"function"!=typeof this[b])throw new Error('Handler "'+b+'" for the interest "'+c+'" is missing!');f.push(a.registerHandler(c,this[b],this))}return f},Gremlin.Module("interests",{extend:function(b){return b.prototype.emit=function(b,c){return a.dispatch(b,c)}},bind:function(a){return b.call(a)}})}).call(this);
 /**//*! gremlinjs-jquery - v0.3.0 - 2013-11-10 */(function(){var a,b,c={}.hasOwnProperty;a=function(){var a,b,d,e;if("object"==typeof this.constructor.elements){d=this.constructor.elements,e=[];for(b in d)c.call(d,b)&&(a=d[b],e.push(this[a]=this.$el.find(b)));return e}},b=function(){var a,b,d,e,f,g=this;if(a=this,"object"==typeof this.constructor.events){f=this.constructor.events,e=function(b,c){var d,e,f,h,i;if("string"!=typeof c)throw new TypeError("Event selectors have to be referenced by strings!");if("function"!=typeof g[b])throw new TypeError("Event '"+c+"' can't be bound to '"+g.name+"."+b+"', as the type is "+typeof g[b]);return f=g[b],e=c.indexOf(" "),h=-1!==e,d=h?c.substr(0,e):c,i=h?c.substr(e+1):null,g.$el.on(d,i,function(b){return f.call(a,b,this),!0})};for(b in f)c.call(f,b)&&(d=f[b],e(d,b));return!0}},Gremlin.Module("jquery",{extend:function(){},bind:function(c){return c.$el=$(c.el),a.call(c),b.call(c)}})}).call(this);

(function() {
  var Index;

  Index = (function() {
    var START, STEP;

    START = 0;

    STEP = 1;

    function Index(_length, _position) {
      this._length = _length;
      this._position = _position;
    }

    Index.prototype.next = function() {
      if (this.hasMore()) {
        return this._position += STEP;
      }
    };

    Index.prototype.prev = function() {
      if (this.hasLess()) {
        return this._position -= STEP;
      }
    };

    Index.prototype.hasMore = function() {
      return this._position + STEP < this._length;
    };

    Index.prototype.hasLess = function() {
      return this._position - STEP >= START;
    };

    Index.prototype.getPosition = function() {
      return this._position;
    };

    return Index;

  })();

  G.Package('slider.Index', Index);

}).call(this);

/*
//# sourceMappingURL=Index.js.map
*/
 /**/(function() {
  var Spinner;

  Spinner = (function() {
    var CSS_SPINNER_LOADING;

    CSS_SPINNER_LOADING = 'spinner_state-active';

    function Spinner() {
      this._$spinner = $('<span class="spinner spinner_position-centered"></span>');
    }

    Spinner.prototype._toggle = function(show) {
      return this._$spinner.toggleClass(CSS_SPINNER_LOADING, show);
    };

    Spinner.prototype.show = function() {
      return this._toggle(true);
    };

    Spinner.prototype.hide = function() {
      return this._toggle(false);
    };

    Spinner.prototype.appendTo = function($el) {
      return $el.append(this._$spinner);
    };

    Spinner.prototype.after = function($el) {
      return $el.after(this._$spinner);
    };

    return Spinner;

  })();

  G.Package('ui.Spinner', Spinner);

}).call(this);

/*
//# sourceMappingURL=Spinner.js.map
*/
 /**/(function() {
  var ElementRow;

  ElementRow = (function() {
    var INCLUDE_MARGIN, INITAL_WIDTH, rowId;

    INITAL_WIDTH = 0;

    INCLUDE_MARGIN = true;

    rowId = 0;

    function ElementRow(_maxWidth) {
      this._maxWidth = _maxWidth;
      this._rowId = ++rowId;
      this._width = INITAL_WIDTH;
      this._elements = [];
    }

    ElementRow.prototype.canAddElement = function($el) {
      var width;
      width = this._getElementwidth($el);
      return (this._width + width) <= this._maxWidth;
    };

    ElementRow.prototype.addElement = function($el) {
      this._width += this._getElementwidth($el);
      return this._elements.push($el);
    };

    ElementRow.prototype._getElementwidth = function($el) {
      return $el.outerWidth(INCLUDE_MARGIN);
    };

    ElementRow.prototype.equalize = function() {
      var UiTools, el, max, _i, _len, _ref, _results;
      UiTools = G.Package.require('ui.Tools');
      max = UiTools.getMaxHeight(this._elements);
      _ref = this._elements;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        el = _ref[_i];
        _results.push($(el).height(max));
      }
      return _results;
    };

    return ElementRow;

  })();

  G.Package('heightEqualizer.ElementRow', ElementRow);

}).call(this);

/*
//# sourceMappingURL=ElementRow.js.map
*/
 /**/(function() {
  var RowCollection;

  RowCollection = (function() {
    function RowCollection() {
      this._rows = [];
    }

    RowCollection.prototype.add = function(row) {
      return this._rows.push(row);
    };

    RowCollection.prototype.getLast = function() {
      var last;
      last = this._rows.length - 1;
      return this._rows[last];
    };

    RowCollection.prototype.forEach = function(cb) {
      var row, _i, _len, _ref, _results;
      _ref = this._rows;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        row = _ref[_i];
        _results.push(cb(row));
      }
      return _results;
    };

    return RowCollection;

  })();

  G.Package('heightEqualizer.RowCollection', RowCollection);

}).call(this);

/*
//# sourceMappingURL=RowCollection.js.map
*/
 /**/(function() {
  var DesktopNavToggle;

  DesktopNavToggle = (function() {
    var MIN_HEIGHT;

    MIN_HEIGHT = 0;

    function DesktopNavToggle(height) {
      this.height = height;
      this.isVisible = this.height > MIN_HEIGHT;
    }

    return DesktopNavToggle;

  })();

  G.Package('interestData.DesktopNavToggle', DesktopNavToggle);

}).call(this);

/*
//# sourceMappingURL=DesktopNavToggle.js.map
*/
 /**/(function() {
  var NavbarToggle;

  NavbarToggle = (function() {
    function NavbarToggle(_id) {
      this._id = _id;
    }

    NavbarToggle.prototype.isNavbar = function(id) {
      return id === this._id;
    };

    return NavbarToggle;

  })();

  G.Package('interestData.NavbarToggle', NavbarToggle);

}).call(this);

/*
//# sourceMappingURL=NavbarToggle.js.map
*/
 /**/(function() {
  var TabShown;

  TabShown = (function() {
    function TabShown(el) {
      this.el = el;
    }

    TabShown.prototype.isChildOf = function(element) {
      return $.contains(element, this.el);
    };

    TabShown.prototype.isParentOf = function(element) {
      return $.contains(this.el, element);
    };

    return TabShown;

  })();

  G.Package('interestData.TabShown', TabShown);

}).call(this);

/*
//# sourceMappingURL=TabShown.js.map
*/
 /**/(function() {
  G.Package('interests', {
    MOBILE_NAV_TOGGLE: 'MOBILE_NAV_TOGGLE',
    DESKTOP_NAV_TOGGLE: 'DESKTOP_NAV_TOGGLE',
    NAVBAR_TOGGLE: 'NAVBAR_TOGGLE',
    TAB_SHOWN: 'TAB_SHOWN',
    SLIDING_PANEL_CHANGED: 'SLIDING_PANEL_CHANGED'
  });

}).call(this);

/*
//# sourceMappingURL=interests.js.map
*/
 /**/(function() {
  var PopupOptions;

  PopupOptions = {
    IMAGE: {
      type: 'image',
      closeOnContentClick: true,
      closeBtnInside: false,
      fixedContentPos: true,
      mainClass: 'mfp-no-margins mfp-with-zoom',
      image: {
        verticalFit: true
      },
      zoom: {
        enabled: true,
        duration: 300
      }
    },
    GALLERY: {
      delegate: 'a',
      type: 'image',
      closeOnContentClick: false,
      closeBtnInside: false,
      mainClass: 'mfp-with-zoom mfp-img-mobile',
      image: {
        verticalFit: true,
        titleSrc: function(item) {
          return item.el.attr('title') + ' &middot; <a class="image-source-link" href="' + item.el.attr('data-source') + '" target="_blank" rel="noopener noreferrer">image source</a>';
        }
      },
      gallery: {
        enabled: true
      },
      zoom: {
        enabled: true,
        duration: 300,
        opener: function(element) {
          return element.find('img');
        }
      }
    }
  };

  G.Package('lightbox.PopupOptions', PopupOptions);

}).call(this);

/*
//# sourceMappingURL=PopupOptions.js.map
*/
 /**/(function() {
  var FLYOUT_NEXT_SELECTOR;

  FLYOUT_NEXT_SELECTOR = '[data-nav-flyout]';

  G.Package('navigation.Helper', {
    getFlyout: function($toggle) {
      return $toggle.nextAll("" + FLYOUT_NEXT_SELECTOR + ":first");
    }
  });

}).call(this);

/*
//# sourceMappingURL=Helper.js.map
*/
 /**/(function() {
  var Spinner;

  Spinner = (function() {
    function Spinner(isCentered) {
      this._$spinner = $('<span class="spinner"></span>');
      this._$spinner.toggleClass('spinner_pos-center', isCentered);
    }

    Spinner.prototype.show = function() {
      this._$spinner.fadeTo(0, 0).addClass('spinner_state-active');
      return this._$spinner.delay(500).fadeTo(120, 1);
    };

    Spinner.prototype.hide = function() {
      this._$spinner.stop(true, true).removeAttr('style');
      return this._$spinner.removeClass('spinner_state-active');
    };

    Spinner.prototype.appendTo = function($el) {
      $el.append(this._$spinner);
      return this._$spinner.after('<span class="spinner__cover"></span>');
    };

    Spinner.prototype.after = function($el) {
      $el.after(this._$spinner);
      return this._$spinner.after('<span class="spinner__cover"></span>');
    };

    return Spinner;

  })();

  G.Package('ui.Spinner', Spinner);

}).call(this);

/*
//# sourceMappingURL=Spinner.js.map
*/
 /**/(function() {
  var Tools;

  Tools = (function() {
    var INCLUDE_MARGINS;

    function Tools() {}

    INCLUDE_MARGINS = false;

    Tools.getMaxHeight = function(elements) {
      var el, heights;
      heights = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          _results.push($(el).outerHeight(INCLUDE_MARGINS));
        }
        return _results;
      })();
      return Math.max.apply(Math, heights);
    };

    return Tools;

  })();

  G.Package('ui.Tools', Tools);

}).call(this);

/*
//# sourceMappingURL=Tools.js.map
*/
 /* CAUTION HOT: THIS IS NOT BOOTSTRAP !!! */
 /**/(function() {
  var BootstrapTabs,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  BootstrapTabs = (function(_super) {
    var BOOTSTRAP_TAB_SHOWN, Interests, TabShown;

    __extends(BootstrapTabs, _super);

    BOOTSTRAP_TAB_SHOWN = 'shown.bs.tab';

    TabShown = G.Package.require('interestData.TabShown');

    Interests = G.Package.require('interests');

    BootstrapTabs.include = ['jquery', 'interests'];

    BootstrapTabs.events = {
      'shown.bs.tab [data-toggle="tab"]': '_onTabShown'
    };

    function BootstrapTabs() {
      BootstrapTabs.__super__.constructor.apply(this, arguments);
    }

    BootstrapTabs.prototype._onTabShown = function(e) {
      var data;
      data = new TabShown(this.el);
      return this.emit(Interests.TAB_SHOWN, data);
    };

    return BootstrapTabs;

  })(G.Gizmo);

  G.add('BootstrapTabs', BootstrapTabs);

}).call(this);

/*
//# sourceMappingURL=BootstrapTabs.js.map
*/
/**/(function() {
  var LinkListBrowser,
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  LinkListBrowser = (function(_super) {
    var Spinner, XHR_ABORT_STATUS;

    __extends(LinkListBrowser, _super);

    XHR_ABORT_STATUS = 'abort';

    Spinner = G.Package.require('ui.Spinner');

    LinkListBrowser.include = ['jquery', 'interests'];

    LinkListBrowser.interests = {
      'TAB_SHOWN': '_onTabShown',
      'SLIDING_PANEL_CHANGED': '_onPanelChanged'
    };

    LinkListBrowser.elements = {
      '[data-link-list-items]': '_$list',
      '[data-link-list-view]': '_$view'
    };

    LinkListBrowser.events = {
      'click [data-link-list-items] a': '_onLinkClick',
      'click [data-link-list-browser-toggle="close"]': '_onCloseView'
    };

    function LinkListBrowser() {
      this._contentFailed = __bind(this._contentFailed, this);
      this._contentLoaded = __bind(this._contentLoaded, this);
      LinkListBrowser.__super__.constructor.apply(this, arguments);
      this._xhr = null;
      this._spinner = new Spinner(true);
      this._spinner.appendTo(this.$el);
    }

    LinkListBrowser.prototype._onLinkClick = function(e) {
      e.preventDefault();
      this._abortLoading();
      this._spinner.show();
      this._xhr = $.get(e.currentTarget.href);
      this._xhr.done(this._contentLoaded);
      return this._xhr.fail(this._contentFailed);
    };

    LinkListBrowser.prototype._contentLoaded = function(content) {
      this._spinner.hide();
      return this._showView(content);
    };

    LinkListBrowser.prototype._contentFailed = function(error) {
      this._spinner.hide();
      this._hideView();
      if (error.statusText !== XHR_ABORT_STATUS) {
        throw new Error(error);
      }
    };

    LinkListBrowser.prototype._showView = function(content) {
      this._$list.hide();
      return this._$view.html(content).show();
    };

    LinkListBrowser.prototype._hideView = function() {
      this._abortLoading();
      this._$list.show();
      return this._$view.empty().hide();
    };

    LinkListBrowser.prototype._onCloseView = function(e) {
      e.preventDefault();
      return this._hideView();
    };

    LinkListBrowser.prototype._onTabShown = function(tabShownData) {
      if (tabShownData.isParentOf(this.el)) {
        return this._hideView();
      }
    };

    LinkListBrowser.prototype._onPanelChanged = function() {
      return this._hideView();
    };

    LinkListBrowser.prototype._abortLoading = function() {
      var _ref;
      if ((_ref = this._xhr) != null) {
        _ref.abort();
      }
      return this._xhr = null;
    };

    return LinkListBrowser;

  })(G.Gizmo);

  G.add('LinkListBrowser', LinkListBrowser);

}).call(this);

/*
//# sourceMappingURL=LinkListBrowser.js.map
*/
 /**/(function() {
  var Site,
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site = (function(_super) {
    var CONTENT_TOP_FLYOUT_PADDING, CSS_BODY_TOGGLED, CSS_FLYOUT_OPENED;

    __extends(Site, _super);

    CSS_BODY_TOGGLED = 'site_mobilenav-opened';

    CSS_FLYOUT_OPENED = 'site_desktopnav-opened';

    CONTENT_TOP_FLYOUT_PADDING = 50;

    Site.include = ['jquery', 'interests'];

    Site.interests = {
      'MOBILE_NAV_TOGGLE': '_onNavToggled',
      'DESKTOP_NAV_TOGGLE': '_onFlyoutToggled'
    };

    function Site() {
      this._onFlyoutToggled = __bind(this._onFlyoutToggled, this);
      this._onNavToggled = __bind(this._onNavToggled, this);
      Site.__super__.constructor.apply(this, arguments);
    }

    Site.prototype._onNavToggled = function(isEnabled) {
      return this.$el.toggleClass(CSS_BODY_TOGGLED, isEnabled);
    };

    Site.prototype._onFlyoutToggled = function(data) {
      var height;
      height = data.isVisible ? data.height - CONTENT_TOP_FLYOUT_PADDING : 0;
      this.$el.css({
        transform: "translate3d(0, " + height + "px, 0)"
      });
      return this.$el.toggleClass(CSS_FLYOUT_OPENED, data.isVisible);
    };

    return Site;

  })(G.Gizmo);

  G.add('Site', Site);

}).call(this);

/*
//# sourceMappingURL=Site.js.map
*/
 /**/(function() {
  var Index, Slider,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Index = G.Package.require('slider.Index');

  Slider = (function(_super) {
    var CSS_DRAGGING, CSS_NEXT_INACTIVE, CSS_PREV_INACTIVE, NO_DRAG, START_INDEX, WIDTH_WITH_MARGINS;

    __extends(Slider, _super);

    START_INDEX = 0;

    WIDTH_WITH_MARGINS = true;

    NO_DRAG = 0;

    CSS_DRAGGING = 'slider_state-dragging';

    CSS_PREV_INACTIVE = 'slider__prev_state-inactive';

    CSS_NEXT_INACTIVE = 'slider__next_state-inactive';

    Slider.include = ['jquery'];

    Slider.events = {
      'click [data-click-prev]': '_onPrev',
      'click [data-click-next]': '_onNext',
      'swipeleft [data-container]': '_onNext',
      'swiperight [data-container]': '_onPrev',
      'dragleft [data-container]': '_onDrag',
      'dragright [data-container]': '_onDrag',
      'dragstart [data-container]': '_onDragStart',
      'dragend [data-container]': '_onDragEnd'
    };

    Slider.elements = {
      '[data-click-prev]': '_$prev',
      '[data-click-next]': '_$next',
      '[data-container]': '_$container',
      '[data-slides]': '_$slides',
      '[data-slides] li': '_$items'
    };

    Slider.prototype._$prev = null;

    Slider.prototype._$next = null;

    Slider.prototype._$container = null;

    Slider.prototype._$slides = null;

    Slider.prototype._$items = null;

    function Slider() {
      var containerWidth, listWidth, times;
      Slider.__super__.constructor.apply(this, arguments);
      containerWidth = this._$container.width();
      listWidth = this._$slides.innerWidth();
      times = Math.ceil(listWidth / containerWidth);
      this._prepareList();
    }

    Slider.prototype._prepareList = function() {
      var containerWidth, item, listWidth, times, _i, _len, _ref;
      listWidth = 0;
      _ref = this._$items;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        item = _ref[_i];
        listWidth += $(item).outerWidth(WIDTH_WITH_MARGINS);
      }
      containerWidth = this._$container.width();
      times = Math.ceil(listWidth / containerWidth);
      this._dragStartIndex = START_INDEX;
      this._index = new Index(times, START_INDEX);
      this._itemDistance = parseInt(this._$items.eq(1).css('margin-left'), 10);
      this._moveOffset = containerWidth;
      this._currentOffset = 0;
      return this._refreshList();
    };

    Slider.prototype._refreshList = function() {
      var currentPage, offset;
      currentPage = this._index.getPosition();
      offset = currentPage === START_INDEX ? 0 : -((this._moveOffset + this._itemDistance) * currentPage);
      this._currentOffset = offset;
      this._updateNav();
      return this._moveList(offset);
    };

    Slider.prototype._moveList = function(deltaX) {
      var opts;
      opts = {
        'transform': "translate3d(" + deltaX + "px, 0, 0)"
      };
      return this._$slides.css(opts);
    };

    Slider.prototype._dragList = function(deltaX) {
      var dragDelta;
      dragDelta = this._currentOffset + deltaX;
      return this._moveList(dragDelta);
    };

    Slider.prototype._onDrag = function(e) {
      var deltaX, gesture;
      e.preventDefault();
      e.stopPropagation();
      gesture = e.gesture;
      gesture.preventDefault();
      deltaX = gesture.deltaX;
      return this._dragList(deltaX);
    };

    Slider.prototype._onDragStart = function(e) {
      e.preventDefault();
      e.stopPropagation();
      this._dragStartIndex = this._index.getPosition();
      return this.$el.addClass(CSS_DRAGGING);
    };

    Slider.prototype._onDragEnd = function(e) {
      var deltaX, gesture, isEnough, isPrev, method, wasntSwiped;
      e.preventDefault();
      e.stopPropagation();
      this.$el.removeClass(CSS_DRAGGING);
      gesture = e.gesture;
      deltaX = gesture.deltaX;
      wasntSwiped = this._dragStartIndex === this._index.getPosition();
      isEnough = Math.abs(deltaX) > (this._moveOffset / 4);
      if (isEnough && wasntSwiped) {
        isPrev = deltaX > 0;
        method = isPrev ? 'prev' : 'next';
        this._index[method]();
      }
      return this._refreshList();
    };

    Slider.prototype._onResize = function() {
      return this._prepareList();
    };

    Slider.prototype._updateNav = function() {
      this._$prev.toggleClass(CSS_PREV_INACTIVE, !this._index.hasLess());
      return this._$next.toggleClass(CSS_NEXT_INACTIVE, !this._index.hasMore());
    };

    Slider.prototype._onPrev = function(e) {
      e.preventDefault();
      this._index.prev();
      return this._refreshList();
    };

    Slider.prototype._onNext = function(e) {
      e.preventDefault();
      this._index.next();
      return this._refreshList();
    };

    Slider.prototype._onSlides = function(e) {};

    return Slider;

  })(G.Gizmo);

  G.add('Slider', Slider);

}).call(this);

/*
//# sourceMappingURL=Slider.js.map
*/
 /**/(function() {
  var SlidingPanels,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  SlidingPanels = (function(_super) {
    var COLLAPSE_HIDE, COLLAPSE_SHOW, CSS_NO_TRANSITIONS, interests;

    __extends(SlidingPanels, _super);

    CSS_NO_TRANSITIONS = 'no-transition';

    COLLAPSE_SHOW = 'show';

    COLLAPSE_HIDE = 'hide';

    interests = G.Package.require('interests');

    SlidingPanels.include = ['jquery', 'interests'];

    SlidingPanels.events = {
      'click [data-panel-toggle]': '_onPanelToggleClick'
    };

    SlidingPanels.elements = {
      '[data-panel-toggle-wrapper]': '_$toggleWrappers',
      '[data-panel]': '_$panels'
    };

    function SlidingPanels() {
      SlidingPanels.__super__.constructor.apply(this, arguments);
      this._initPanels();
    }

    SlidingPanels.prototype._initPanels = function() {
      return this._$panels.collapse({
        toggle: false
      });
    };

    SlidingPanels.prototype._onPanelToggleClick = function(e) {
      var $targetPanel, $toggle, $toggleWrapper, isPanelActive,
        _this = this;
      e.preventDefault();
      $toggle = $(e.currentTarget);
      $toggleWrapper = this._getToggleWrapper($toggle);
      $targetPanel = this._getTogglePanel($toggle);
      isPanelActive = this._isActiveToggle($toggleWrapper);
      if (isPanelActive) {
        this._$panels.removeClass(CSS_NO_TRANSITIONS);
        this._$toggleWrappers.removeClass(this.data.cssPanelActive);
        this.$el.removeClass(this.data.cssPanelShow);
        setTimeout(function() {
          return _this._$panels.collapse(COLLAPSE_HIDE);
        }, 400);
      } else {
        if (this._isPanelOpened()) {
          this._$panels.addClass(CSS_NO_TRANSITIONS);
        }
        this.$el.addClass(this.data.cssPanelShow);
        this._$panels.not($targetPanel).collapse(COLLAPSE_HIDE);
        $targetPanel.collapse(COLLAPSE_SHOW);
        this._$toggleWrappers.removeClass(this.data.cssPanelActive);
        $toggleWrapper.addClass(this.data.cssPanelActive);
      }
      return this.emit(interests.SLIDING_PANEL_CHANGED);
    };

    SlidingPanels.prototype._getToggleWrapper = function($toggle) {
      return $toggle.closest('[data-panel-toggle-wrapper]');
    };

    SlidingPanels.prototype._getTogglePanel = function($toggle) {
      var id;
      id = $toggle.attr('href');
      return $(id);
    };

    SlidingPanels.prototype._isActiveToggle = function($toggleWrapper) {
      return $toggleWrapper.hasClass(this.data.cssPanelActive);
    };

    SlidingPanels.prototype._isPanelOpened = function() {
      return this.$el.hasClass(this.data.cssPanelShow);
    };

    return SlidingPanels;

  })(G.Gizmo);

  G.add('SlidingPanels', SlidingPanels);

}).call(this);

/*
//# sourceMappingURL=SlidingPanels.js.map
*/
 /**/(function() {
  var Index, TimetablePager,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Index = G.Package.require('slider.Index');

  TimetablePager = (function(_super) {
    var CSS_ACTIVE_ITEM, CSS_DISABLED_BUTTON, START_INDEX;

    __extends(TimetablePager, _super);

    START_INDEX = 0;

    CSS_ACTIVE_ITEM = 'timetablebox__item_state-active';

    CSS_DISABLED_BUTTON = 'timetablebox__pager_state-disabled';

    TimetablePager.include = ['jquery'];

    TimetablePager.events = {
      'click [data-click-prev]': '_onPrev',
      'click [data-click-next]': '_onNext'
    };

    TimetablePager.elements = {
      '[data-click-prev]': '_$prev',
      '[data-click-next]': '_$next',
      '.timetablebox__item': '_$items'
    };

    function TimetablePager() {
      TimetablePager.__super__.constructor.apply(this, arguments);
      this._index = new Index(this._$items.length, START_INDEX);
      this._renderList();
    }

    TimetablePager.prototype._onPrev = function(e) {
      e.preventDefault();
      this._index.prev();
      return this._renderList();
    };

    TimetablePager.prototype._onNext = function(e) {
      e.preventDefault();
      this._index.next();
      return this._renderList();
    };

    TimetablePager.prototype._renderList = function() {
      var current;
      current = this._index.getPosition();
      this._$items.removeClass(CSS_ACTIVE_ITEM).eq(current).addClass(CSS_ACTIVE_ITEM);
      this._$prev.toggleClass(CSS_DISABLED_BUTTON, !this._index.hasLess());
      return this._$next.toggleClass(CSS_DISABLED_BUTTON, !this._index.hasMore());
    };

    return TimetablePager;

  })(G.Gizmo);

  G.add('TimetablePager', TimetablePager);

}).call(this);

/*
//# sourceMappingURL=TimetablePager.js.map
*/
 /**/(function() {
  var MobileNavToggle,
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  MobileNavToggle = (function(_super) {
    var interests, isNavToggled;

    __extends(MobileNavToggle, _super);

    isNavToggled = false;

    interests = G.Package.require('interests');

    MobileNavToggle.include = ['jquery', 'interests'];

    MobileNavToggle.events = {
      'click': '_onClick'
    };

    function MobileNavToggle() {
      this._onClick = __bind(this._onClick, this);
      MobileNavToggle.__super__.constructor.apply(this, arguments);
    }

    MobileNavToggle.prototype._onClick = function(e) {
      e.preventDefault();
      isNavToggled = !isNavToggled;
      return this.emit(interests.MOBILE_NAV_TOGGLE, isNavToggled);
    };

    return MobileNavToggle;

  })(G.Gizmo);

  G.add('MobileNavToggle', MobileNavToggle);

}).call(this);

/*
//# sourceMappingURL=MobileNavToggle.js.map
*/

/**/(function() {
  var MobileNavigation,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  MobileNavigation = (function(_super) {
    var CSS_TOGGLE_OPEN, Helper, SLIDE_DURATION;

    __extends(MobileNavigation, _super);

    CSS_TOGGLE_OPEN = 'mobile-toggle_state-active';

    SLIDE_DURATION = 210;

    Helper = G.Package.require('navigation.Helper');

    MobileNavigation.include = ['interests', 'jquery'];

    MobileNavigation.interests = {
      'MOBILE_NAV_TOGGLE': '_onToggle'
    };

    MobileNavigation.events = {
      'click [data-nav-toggle]': '_onToggleLevelOne'
    };

    MobileNavigation.elements = {
      '[data-nav-toggle]': '_$toggles',
      '[data-nav-toggle="level-2"]': '_$togglesLevelTwo'
    };

    function MobileNavigation() {
      MobileNavigation.__super__.constructor.apply(this, arguments);
      this._addToggleIcons();
      this._addToggleHeaders();
    }

    MobileNavigation.prototype._addToggleIcons = function() {
      return this._$toggles.append('<i class="fa fa-angle-down"></i> ');
    };

	MobileNavigation.prototype._addToggleHeaders = function() {
		var $flyout, $toggle, text, toggle, _i, _len, _ref, _results, href;
		_ref = this._$togglesLevelTwo;
		_results = [];
		for (_i = 0, _len = _ref.length; _i < _len; _i++) {
			toggle = _ref[_i];
			$toggle = $(toggle);
			$flyout = Helper.getFlyout($toggle);
			text = $toggle.text();
			href = $toggle.attr("href");
			_results.push($flyout.prepend("<li class='nav-section__title nav-section__title_mobile-link'><a href=" + href + " tabindex=\"-1\">" + text + "</a></li>"));
		}
		return _results;
	};

    MobileNavigation.prototype._onToggle = function(isVisible) {
      var fn,
        _this = this;
      if (!_isDesktop.matches) {
        fn = isVisible ? 'slideDown' : 'slideUp';
        return this.$el.stop()[fn](SLIDE_DURATION, function() {
          return _this.$el.css('height', '');
        });
      }
    };

      MobileNavigation.prototype._onToggleLevelOne = function(e) {
	  var $flyout, $toggle;
	  if (!_isDesktop.matches) {

		  // Links within level-2 shall be directly clickable if they don´t contain links in a sublevel
		  var linkClickable = false;
		  if(!e.currentTarget.parentNode.className.match(/nav-section__level-1/)) {

			   $(e.currentTarget.parentNode.children).each(function(){
				   if($(this).is('ul')) {
					   linkClickable = true;
				   }
			   });

			  if(!linkClickable === true) {
				  return true;
			  }
		  }

		e.preventDefault();
		$toggle = $(e.currentTarget);
		$flyout = Helper.getFlyout($toggle);
		$toggle.toggleClass(CSS_TOGGLE_OPEN);

		return $flyout.stop().slideToggle(SLIDE_DURATION);
		}
	};

    return MobileNavigation;

  })(G.Gizmo);

  G.add('MobileNavigation', MobileNavigation);

}).call(this);

/*
//# sourceMappingURL=MobileNavigation.js.map
*/
 /**/(function() {
  var Navbar,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Navbar = (function(_super) {
    var CSS_NAVBAR_ACTIVE, SCROLL_OFFSET;

    __extends(Navbar, _super);

    CSS_NAVBAR_ACTIVE = 'navigation-main__panel_state-active';

    SCROLL_OFFSET = 60;

    Navbar.include = ['jquery', 'interests'];

    Navbar.interests = {
      'NAVBAR_TOGGLE': '_onNavbarToggle'
    };

    Navbar.elements = {
      'input:first': '_$firstInput'
    };

    function Navbar() {
      Navbar.__super__.constructor.apply(this, arguments);
    }

    Navbar.prototype._onNavbarToggle = function(eventData) {
      var isThisNavbar;
      isThisNavbar = eventData.isNavbar(this.el.id);
      this.$el.toggleClass(CSS_NAVBAR_ACTIVE, isThisNavbar);
      if (isThisNavbar) {
        this._$firstInput.focus();
      }
      if (isThisNavbar && !_isDesktop.matches) {
        return $('html, body').animate({
          scrollTop: this.$el.offset().top - SCROLL_OFFSET
        });
      }
    };

    return Navbar;

  })(G.Gizmo);

  G.add('Navbar', Navbar);

}).call(this);

/*
//# sourceMappingURL=Navbar.js.map
*/
 /**/(function() {
  var NavbarToggle,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  NavbarToggle = (function(_super) {
    var CSS_TOGGLE_ACTIVE, Interests, NavbarToggleData;

    __extends(NavbarToggle, _super);

    CSS_TOGGLE_ACTIVE = 'navigation-main__button_active';

    Interests = G.Package.require('interests');

    NavbarToggleData = G.Package.require('interestData.NavbarToggle');

    NavbarToggle.include = ['jquery', 'interests'];

    NavbarToggle.interests = {
      'NAVBAR_TOGGLE': '_onNavbarToggle'
    };

    NavbarToggle.events = {
      'click': '_onClick'
    };

    function NavbarToggle() {
      NavbarToggle.__super__.constructor.apply(this, arguments);
      this._id = this.el.getAttribute('href').replace('#', '');
    }

    NavbarToggle.prototype._onClick = function(e) {
      var data;
      e.preventDefault();
      data = new NavbarToggleData(this._id);
      return this.emit(Interests.NAVBAR_TOGGLE, data);
    };

    NavbarToggle.prototype._onNavbarToggle = function(eventData) {
      var isThisNavbar;
      isThisNavbar = eventData.isNavbar(this._id);
      return this.$el.toggleClass(CSS_TOGGLE_ACTIVE, isThisNavbar);
    };

    return NavbarToggle;

  })(G.Gizmo);

  G.add('NavbarToggle', NavbarToggle);

}).call(this);

/*
//# sourceMappingURL=NavbarToggle.js.map
*/
 /**/(function() {
  var SiteNavObserver,
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  SiteNavObserver = (function(_super) {
    var CSS_DESKTOP_NAVIGATION_TOGGLED, CSS_MOBILE_NAVIGATION_TOGGLED, interests, interestsObj;

    __extends(SiteNavObserver, _super);

    CSS_MOBILE_NAVIGATION_TOGGLED = 'mobile-nav-openend';

    CSS_DESKTOP_NAVIGATION_TOGGLED = 'desktop-nav-openend';

    interests = G.Package.require('interests');

    interestsObj = {};

    interestsObj[interests.MOBILE_NAV_TOGGLE] = '_onMobileNavToggled';

    interestsObj[interests.DESKTOP_NAV_TOGGLE] = '_onDesktopNavToggled';

    SiteNavObserver.interests = interestsObj;

    SiteNavObserver.include = ['jquery', 'interests'];

    function SiteNavObserver() {
      this._onDesktopNavToggled = __bind(this._onDesktopNavToggled, this);
      this._onMobileNavToggled = __bind(this._onMobileNavToggled, this);
      SiteNavObserver.__super__.constructor.apply(this, arguments);
    }

    SiteNavObserver.prototype._onMobileNavToggled = function(isEnabled) {
      return this.$el.toggleClass(CSS_MOBILE_NAVIGATION_TOGGLED, isEnabled);
    };

    SiteNavObserver.prototype._onDesktopNavToggled = function(data) {
      return this.$el.toggleClass(CSS_DESKTOP_NAVIGATION_TOGGLED, data.isVisible);
    };

    return SiteNavObserver;

  })(G.Gizmo);

  G.add('SiteNavObserver', SiteNavObserver);

}).call(this);

/*
//# sourceMappingURL=SiteNavObserver.js.map
*/
 /**/(function() {
  var SiteNavigation,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  SiteNavigation = (function(_super) {
    var CSS_FLYOUT_ANIMATION_PAUSED, CSS_FLYOUT_SWITCHED_IN, CSS_FLYOUT_SWITCHED_OUT, CSS_TOGGLE_ACTIVE, DesktopNavToggle, Helper, NAV_HEIGHT_ORIGIN, NAV_SLIDE_DURATION, interests;

    __extends(SiteNavigation, _super);

    CSS_TOGGLE_ACTIVE = 'nav-section__toggle_state-active';

    CSS_FLYOUT_ANIMATION_PAUSED = 'nav-section__flyout_animation-paused';

    CSS_FLYOUT_SWITCHED_OUT = 'nav-section__flyout_transition-switch-out';

    CSS_FLYOUT_SWITCHED_IN = 'nav-section__flyout_transition-switch-in';

    NAV_SLIDE_DURATION = 270;

    NAV_HEIGHT_ORIGIN = 0;

    interests = G.Package.require('interests');

    Helper = G.Package.require('navigation.Helper');

    DesktopNavToggle = G.Package.require('interestData.DesktopNavToggle');

    SiteNavigation.include = ['jquery', 'interests'];

    SiteNavigation.interests = {
      'NAVBAR_TOGGLE': '_onNavbarToggle'
    };

    SiteNavigation.elements = {
      '[data-nav-flyout]': '_$flyouts',
      '[data-nav-toggle="level-1"]': '_$toggles'
    };

    SiteNavigation.events = {
      'click [data-nav-toggle="level-1"]': '_onToggleLevelOne'
    };

    function SiteNavigation() {
      SiteNavigation.__super__.constructor.apply(this, arguments);
    }

    SiteNavigation.prototype._onToggleLevelOne = function(e) {
      if (_isDesktop.matches) {
        e.preventDefault();
        return this._toggleFlyout($(e.currentTarget));
      }
    };

    SiteNavigation.prototype._onNavbarToggle = function(eventData) {
      var $activeToggle;
      if (_isDesktop.matches) {
        $activeToggle = this._$toggles.filter("." + CSS_TOGGLE_ACTIVE);
        return this._toggleFlyout($activeToggle);
      }
    };

    SiteNavigation.prototype._toggleFlyout = function($toggle) {
      var $activeToggle, isCurrentFlyout, isFlyoutOpened;
      $activeToggle = this._$toggles.filter("." + CSS_TOGGLE_ACTIVE);
      isCurrentFlyout = $toggle.hasClass(CSS_TOGGLE_ACTIVE);
      isFlyoutOpened = $activeToggle.length > 0;
      this._$flyouts.removeClass("" + CSS_FLYOUT_SWITCHED_OUT + " " + CSS_FLYOUT_SWITCHED_IN);
      if (isCurrentFlyout) {
        return this._closeFlyout($toggle);
      } else if (isFlyoutOpened) {
        return this._switchFlyout($activeToggle, $toggle);
      } else {
        return this._openFlyout($toggle);
      }
    };

    SiteNavigation.prototype._closeFlyout = function($toggle) {
      var $flyout;
      $toggle.removeClass(CSS_TOGGLE_ACTIVE);
      $flyout = this._getFlyout($toggle);
      this._removeTabindex($flyout);
      this._moveFlyout($flyout, NAV_HEIGHT_ORIGIN);
      return this._bubbleNavToggle(NAV_HEIGHT_ORIGIN);
    };

    SiteNavigation.prototype._switchFlyout = function($activeToggle, $toggle) {
      var $activeFlyout, $flyout, flyoutHeight, oldHeight;
      $activeFlyout = this._getFlyout($activeToggle);
      $flyout = this._getFlyout($toggle);
      oldHeight = this._getFlyoutHeight($activeFlyout);
      flyoutHeight = this._getFlyoutHeight($flyout);
      $activeFlyout.addClass(CSS_FLYOUT_SWITCHED_OUT);
      $flyout.addClass(CSS_FLYOUT_SWITCHED_IN);
      $activeToggle.removeClass(CSS_TOGGLE_ACTIVE);
      $toggle.addClass(CSS_TOGGLE_ACTIVE);
      this._removeTabindex($activeFlyout);
      this._addTabindex($flyout, this._getTabindex($toggle));
      this._moveFlyout($flyout, flyoutHeight);
      this._moveFlyout($activeFlyout, NAV_HEIGHT_ORIGIN);
      return this._bubbleNavToggle(flyoutHeight);
    };

    SiteNavigation.prototype._openFlyout = function($toggle) {
      var $flyout, flyoutHeight;
      $flyout = this._getFlyout($toggle);
      flyoutHeight = this._getFlyoutHeight($flyout);
      $toggle.addClass(CSS_TOGGLE_ACTIVE);
      this._addTabindex($flyout, this._getTabindex($toggle));
      this._moveFlyout($flyout, flyoutHeight);
      return this._bubbleNavToggle(flyoutHeight);
    };

    SiteNavigation.prototype._addTabindex = function($flyout, index) {
      var $links;
      $links = $flyout.find('a:not(.nav-section__title_mobile-link)');
      return $links.attr('tabindex', index);
    };

    SiteNavigation.prototype._removeTabindex = function($flyout) {
      var $links;
      $links = $flyout.find('a');
      return $links.attr('tabindex', -1);
    };

    SiteNavigation.prototype._getTabindex = function($toggle) {
      return $toggle.attr('tabindex');
    };

    SiteNavigation.prototype._moveFlyout = function($flyout, height) {
        return $flyout.css({
          transform: "translate3d(0, " + height + "px, 0)"
        });
    };

    SiteNavigation.prototype._bubbleNavToggle = function(height) {
      var data;
      data = new DesktopNavToggle(height);
      return this.emit(interests.DESKTOP_NAV_TOGGLE, data);
    };

    SiteNavigation.prototype._getFlyout = function($toggle) {
      return Helper.getFlyout($toggle);
    };

    SiteNavigation.prototype._getFlyoutHeight = function($flyout) {
      return $flyout.innerHeight();
    };

    return SiteNavigation;

  })(G.Gizmo);

  G.add('SiteNavigation', SiteNavigation);

}).call(this);

/*
//# sourceMappingURL=SiteNavigation.js.map
*/
 /**/(function() {
  var SitenavToggle,
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  SitenavToggle = (function(_super) {
    var isNavToggled;

    __extends(SitenavToggle, _super);

    isNavToggled = false;

    SitenavToggle.include = ['jquery', 'interests'];

    SitenavToggle.events = {
      'click': '_onClick'
    };

    function SitenavToggle() {
      this._onClick = __bind(this._onClick, this);
      SitenavToggle.__super__.constructor.apply(this, arguments);
    }

    SitenavToggle.prototype._onClick = function(e) {
      e.preventDefault();
      isNavToggled = !isNavToggled;
      return this.emit('siteNavToggled', isNavToggled);
    };

    return SitenavToggle;

  })(G.Gizmo);

  G.add('SitenavToggle', SitenavToggle);

}).call(this);

/*
//# sourceMappingURL=MobileNavToggle.js.map
*/
